import $ from 'jquery';
import Select from 'blocks/select/select';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaWayForm',
			dom: {
				thankyou: '#yotaWayThankyou',
				selects: [
					'#wayFormPositionExpirience',
					'#wayFormExperienceBoss',
					'#wayFormExperience',
					'#wayFormSubsidiary'
				],
				shake: '#yotaWayShake',
				field: '.js-field',
				select: '.js-select',
				input: {
					field: '.js-field-input',
					select: '.js-select-input'
				}
			},
			classes: {
				thankyou: 'b-way-thankyou_state_open',
				error: {
					field: 'b-field_state_error',
					select: 'b-select_state_error'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$thankyou = $(this.options.dom.thankyou);
		this.$selects = this.$el.find(this.options.dom.selects.join(', '));
		this.$field = this.$el.find(this.options.dom.field);
		this.$select = this.$el.find(this.options.dom.select);
		this.$shake = this.$el.find(this.options.dom.shake);
		return this;
	}

	onSubmit(event) {
		const self = this;
		const valid = self.validate();

		if (valid) {
			$.ajax({
				url: self.$el.attr('action'),
				type: self.$el.attr('method'),
				data: self.$el.serialize(),
				dataType: 'json',
				success: function (json) {
					if (json.success) {
						self.$thankyou.addClass(self.options.classes.thankyou);
					} else {
						/* eslint no-alert: 0 */
						alert(self.$el.data('error'));
					}
				}
			});
		} else {
			$(() => new Animation({el: self.$shake}).play('shake'));
		}
		event.preventDefault();
	}

	validate() {
		const self = this;
		let valid = true;
		self.$field.each(function () {
			const $field = $(this);
			const $input = $field.find(self.options.dom.input.field);
			if ($input.val().trim() == '') {
				$field.addClass(self.options.classes.error.field);
				valid = false;
			}
		});
		self.$select.each(function () {
			const $select = $(this);
			const $input = $select.find(self.options.dom.input.select);
			if ($input.val().trim() == '') {
				$select.addClass(self.options.classes.error.select);
				valid = false;
			}
		});
		return valid;
	}

	fieldFocusIn(event) {
		const $input = $(event.currentTarget);
		const $field = $input.closest(this.$field);
		$field.removeClass(this.options.classes.error.field);
	}

	selectClick(event) {
		const $select = $(event.currentTarget);
		$select.removeClass(this.options.classes.error.select);
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();

			self.selects = [];

			self.$selects.each(function () {
				const select = new Select({el: $(this)}).render();
				self.selects.push(select);
			});

			self.$el.on('submit', self.onSubmit.bind(self));

			self.$field.on('focusin', self.options.dom.input.field, self.fieldFocusIn.bind(self));
			self.$select.on('click', self.selectClick.bind(self));
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/way/form/form.js